import { Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import FormGridRow from "../../../../../common/components/functional/formGridRow/FormGridRow";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { Employment } from "../../../../employment/employmentApi";
import { TargetedShiftInfoText } from "./styles";
import TargetedShiftSettingsDialog from "./TargetedShiftSettingsDialog";

interface Props {
  employment: Employment;
  canEdit: boolean;
}

const TargetedShiftSummary = ({ employment, canEdit }: Props) => {
  const { t } = useTranslation(["talentProfile", "common"]);
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <FormSection
        title={t("talentProfile:targetedShiftSettings")}
        edit={false}
        onEdit={() => setDialogOpen(true)}
        readOnly={!canEdit}
      >
        <FormGridRow labelSize={2} fieldSize={10}>
          <TargetedShiftInfoText sx={{ maxWidth: "85%" }}>
            {t("talentProfile:targetedShiftSummaryText")}
          </TargetedShiftInfoText>
        </FormGridRow>
        <FormGridRow
          label={t("talentProfile:targetingEnabled")}
          labelSize={2}
          fieldSize={10}
        >
          <Typography>
            {(employment.targetedShiftSpec?.targetingRules?.length ?? 0) > 0
              ? t("common:yes")
              : t("common:no")}
          </Typography>
        </FormGridRow>
        <FormGridRow
          label={t("talentProfile:targetingExceptionalSalaries")}
          labelSize={2}
          fieldSize={10}
        >
          <Typography>
            {(employment.targetedShiftSpec?.salaries?.length ?? 0) > 0
              ? t("common:yes")
              : t("common:no")}
          </Typography>
        </FormGridRow>
      </FormSection>
      <TargetedShiftSettingsDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        employment={employment}
        canEdit={canEdit}
      />
    </>
  );
};

export default TargetedShiftSummary;
